/* eslint-disable no-console */
import { LOGGER_PREFIX } from "./config";

const PREFIX = LOGGER_PREFIX;

let debugEnabled = false;

export const Logger = {
  setDebug(enabled: boolean): void {
    debugEnabled = enabled;
  },

  log(message: string, data?: unknown): void {
    if (!debugEnabled) return;
    if (data !== undefined) {
      console.log(`${PREFIX} ${message}`, data);
    } else {
      console.log(`${PREFIX} ${message}`);
    }
  },

  warn(message: string, data?: unknown): void {
    if (data !== undefined) {
      console.warn(`${PREFIX} ${message}`, data);
    } else {
      console.warn(`${PREFIX} ${message}`);
    }
  },

  error(message: string, data?: unknown): void {
    if (data !== undefined) {
      console.error(`${PREFIX} ${message}`, data);
    } else {
      console.error(`${PREFIX} ${message}`);
    }
  },
};
